import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/visitaconcepcion-it/htdocs/it.visitaconcepcion.com/app/components/Comments.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/visitaconcepcion-it/htdocs/it.visitaconcepcion.com/app/components/Header.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/visitaconcepcion-it/htdocs/it.visitaconcepcion.com/app/components/SinglePostContent.js");
;
import(/* webpackMode: "eager" */ "/home/visitaconcepcion-it/htdocs/it.visitaconcepcion.com/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/visitaconcepcion-it/htdocs/it.visitaconcepcion.com/node_modules/next/dist/client/image-component.js");
